<template>
  <div class="pt-5 px-4" :class="!isCollapsed ? 'xl:px-6' : null">

    <div>
      <nuxt-link class="mb-5 xl:mb-10 h-10 block focus-visible:outline-none" to="/" external :class="isCollapsed ? '-mx-1' : null">
        <core-logo v-if="isCollapsed" class="max-h-[38px] mx-auto" variant="circle" />
        <core-logo v-else class="max-w-[184px]" />
      </nuxt-link>
    </div>

    <nav>
      <div
        v-for="section in primaryNavigation"
        class="last:mb-0 last:pb-0"
        :class="section.divider
          ? 'border-b border-gray-200 mb-5 pb-5 xl:mb-6 xl:pb-6'
          : 'mb-2.5 pb-2.5 xl:mb-3 xl:pb-3'"
      >
        <p v-if="section.label && !isCollapsed" class="uppercase text-charcoal-300 text-xs font-semibold tracking-widest mb-3">{{section.label}}</p>
        <ul class="list-unstyled">
          <li v-for="(item, i) in section.items" class="my-0.5 last:-mb-1.5 -mx-4" :class="!isCollapsed ? 'xl:-mx-6' : null">
            <u-tooltip :prevent="!isCollapsed" :text="item.label" :popper="{placement: 'right'}" :ui="{wrapper: 'block', base: 'text-base h-8'}">
              <u-link
                :to="item.to"
                :key="i"
                class="no-underline flex items-center gap-4 px-4 py-2"
                :class="[
                    isCollapsed ? 'justify-center' : 'xl:px-6',
                    isItemActive(item) ? 'bg-ice-100 text-heroblue' : 'text-text-light hover:text-charcoal hover:bg-shell-200'
                  ]"
                @click="emit('item-click')"
                :external="item.external"
                :data-onboarding="item.id"
              >
                <u-icon :name="item.icon" class="text-2xl leading-none" />
                <span class="text-base font-semibold leading-none" v-if="!isCollapsed">{{item.label}}</span>
              </u-link>
            </u-tooltip>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script setup>
  const sessionStore = useSessionStore();
  const {currentUser} = storeToRefs(sessionStore);

  defineProps({
    isCollapsed: {
      type: Boolean
    }
  });

  const emit = defineEmits(['item-click', 'expand-nav']);

  const currentPath = computed(() => useRoute().path);

  function isItemActive(item) {
    return currentPath.value === item.to || (!item.exact && currentPath.value.startsWith(`${item.to}/`));
  }

  const primaryNavigation = computed(() => [
    {
      divider: true,
      items: [
        {
          label: 'Engage',
          icon: 'i-ri-magic-line',
          to: '/engage'
        },
        {
          label: 'All',
          icon: COMMON_ICONS.all,
          to: '/all'
        }
      ]
    }
    ,
    {
      divider: true,
      label: 'AI-Organized',
      items: [
        {
          label: 'Timeline',
          icon: COMMON_ICONS.timeline,
          to: useBuildRoute().toTimeline()
        },
        {
          label: 'People',
          icon: COMMON_ICONS.person,
          to: `/users/${currentUser.value.slug}/people`
        }
      ]
    },
    {
      divider: true,
      label: 'Custom Organized',
      items: [
        {
          label: 'Albums',
          icon: COMMON_ICONS.album,
          to: `/users/${currentUser.value.slug}/albums`,
          id: 'main-navigation-albums'
        },
        {
          label: 'Tags',
          icon: COMMON_ICONS.tag,
          to: `/users/${currentUser.value.slug}/tags`
        }
        /*,
        {
          label: 'Locations',
          icon: 'i-ri-map-pin-2-line',
          to: `/users/${currentUser.value.slug}/tags`
        },
        {
          label: 'Reels',
          icon: 'i-ri-movie-2-line',
          to: `/users/${currentUser.value.slug}`
        }*/
      ]
    },

    {
      divider: true,
      label: 'Sharing',
      items: [
        {
          label: 'Profile',
          icon: 'i-ri-account-circle-line',
          to: `/users/${currentUser.value.slug}`,
          exact: true
        },
        {
          label: 'Connections',
          icon: COMMON_ICONS.connection,
          to: '/connections'
        },
        {
          label: 'Groups',
          icon: COMMON_ICONS.group,
          to: '/groups'
        }
      ]
    },

    {
      label: 'Projects',
      items: [
        {
          label: 'Print',
          icon: COMMON_ICONS.project,
          to: `/users/${currentUser.value.slug}/print-projects`
        },
        {
          label: 'Digitization',
          icon: COMMON_ICONS.digitization,
          to: `/digitization-projects`
        }
      ]
    }

  ]);
</script>
